import { render, staticRenderFns } from "./RenewalTab.vue?vue&type=template&id=549f729c&"
import script from "./RenewalTab.vue?vue&type=script&lang=ts&"
export * from "./RenewalTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports